import apiService from "./apiService";
import { CONTENT_ENDPOINTS } from "./endpoints";
import {
    getContentList as rpcGetContentList,
    getContentById as rpcGetContentById,
    createContent as rpcCreateContent,
    updateContent as rpcUpdateContent,
    deleteContent as rpcDeleteContent,
} from "./postgre/contentApi";

export const getContentList = async () => rpcGetContentList();

export const getContentById = async (id) => rpcGetContentById(id);

export const createContent = async (payload) => rpcCreateContent(payload);

export const updateContent = async (id, payload) => rpcUpdateContent(id, payload);

export const deleteContent = async (id) => rpcDeleteContent(id);

// Cloudflare media cleanup stays on .NET
export const deleteMedia = async ({ cloudflareId, type }) => {
    const response = await apiService.delete(CONTENT_ENDPOINTS.DELETE_MEDIA(cloudflareId), {
        params: { type },
    });
    return response?.data;
};
